import qs from 'qs';

export default ({ retailer, encryptedReturnId, locale }) => {
  const urlBase = `/${retailer}/returns/printerless-info?`;
  const params = qs.stringify({ return_id: encryptedReturnId, locale });

  return `${urlBase}${params}`;
};
